import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { SparkLinePointDtoSchema } from '../contracts';

const _GetCreatedAlertsRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

const GetCreatedAlertsResponseDtoSchema = z.object({
  changePct: z.number().nullable(),
  count: z.number(),
  sparkline: z.object({
    granularity: z.enum(['day', 'week', 'month']),
    points: z.array(SparkLinePointDtoSchema),
  }),
});

export type GetCreatedAlertsRequestDto = z.infer<
  typeof _GetCreatedAlertsRequestDtoSchema
>;
export type GetCreatedAlertsResponseDto = z.infer<
  typeof GetCreatedAlertsResponseDtoSchema
>;

export const getCreatedAlertsKpi = (
  params: GetCreatedAlertsRequestDto,
  config?: AxiosRequestConfig<GetCreatedAlertsRequestDto>
) =>
  api
    .get('alerts/dashboard/created-alerts', { params, ...config })
    .then(responseContract(GetCreatedAlertsResponseDtoSchema));
